import styled, { css } from 'styled-components';
import { rem } from '@packages/ui/tokens/spacing';

/** Legacy reports toolbar: 190px type select + search at ~2:1 width (grid-cols-3). */
export const TOOLBAR_PREFIX_SELECT_WIDTH_PX = 190;

/** Wraps {@link TableToolbar} `renderToolbarPrefix`. */
export const ToolbarPrefixSlot = styled.div`
  flex-shrink: 0;
  width: ${TOOLBAR_PREFIX_SELECT_WIDTH_PX}px;

  & > * {
    margin-bottom: 0;
    width: 100%;
  }
`;

/**
 * Left toolbar block when a prefix is rendered (reports-style). Below lg: `contents`, so
 * search, filter group and suffix button flow and wrap in one row. lg+: flex row in its grid cells.
 */
export const ToolbarPrefixLeftGroup = styled.div`
  display: contents;

  @media (min-width: 1024px) {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    /* Same as other tables' Tailwind \`sm:gap-4\` (1rem on the 10px root). */
    gap: ${rem(10)};
    width: 100%;
  }
`;

/** Prefix + search only (reports-style). Default toolbar search skips this wrapper. */
export const ToolbarSearchGroup = styled.div<{ $attached: boolean }>`
  display: flex;
  min-width: 0;
  align-items: flex-start;
  gap: 0;

  ${({ $attached }) =>
    $attached &&
    css`
      display: grid;
      grid-template-columns: ${TOOLBAR_PREFIX_SELECT_WIDTH_PX}px minmax(0, 2fr);
      /* Grow up to 640px but give way so the filter/reset group stays on the same line. */
      flex: 1 1 ${rem(320)};
      min-width: 0;
      max-width: ${rem(640)};

      @media (min-width: 768px) {
        min-width: ${rem(320)};
      }

      .custom-search {
        min-width: 0;
        width: 100%;
      }

      /* Match DS Select control: --ui-input-border + drop-shadow (Search default uses --ui-border-muted). */
      .custom-search input {
        border: ${rem(1)} solid var(--ui-input-border, var(--ui-border, #d9d9d9));
        width: 100%;
        box-shadow: none;
        filter: drop-shadow(
          ${rem(0)} ${rem(2)} ${rem(4)} var(--ui-input-shadow, var(--ui-shadow-default, rgba(0, 0, 0, 0.12)))
        );
      }

      .custom-search input:hover,
      .custom-search input:focus {
        border-color: var(--ui-input-border-focus, var(--ui-interactive, #1a73e8));
        outline: none;
      }

      /* Phone: stack type select above search, each full width with its own radii. */
      @media (max-width: 639px) {
        /* Own full row, so filter/reset always sit below the search, never beside the select. */
        flex-basis: 100%;
        grid-template-columns: minmax(0, 1fr);
        row-gap: ${rem(8)};
        max-width: none;

        ${ToolbarPrefixSlot} {
          width: 100%;
        }
      }

      /* Wider: select and search join into one control. */
      @media (min-width: 640px) {
        ${ToolbarPrefixSlot} [class*='-control'] {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }

        .custom-search input {
          border-top-left-radius: 0 !important;
          border-bottom-left-radius: 0 !important;
          margin-left: ${rem(-1)};
        }
      }
    `}
`;
